import React from "react";

const MAP = {
  complete: { label: "Complete", cls: "bg-zinc-500/10 text-zinc-300 border-zinc-500/25" },
  processing: { label: "Processing", cls: "bg-sky-500/10 text-sky-400 border-sky-500/25" },
  queued: { label: "Queued", cls: "bg-zinc-700/30 text-zinc-400 border-zinc-700/40" },
  flagged: { label: "Flagged", cls: "bg-red-500/10 text-red-400 border-red-500/25" },
  error: { label: "Error", cls: "bg-red-500/10 text-red-400 border-red-500/25" },
};

export default function StatusBadge({ status }) {
  const cfg = MAP[status] || MAP.queued;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-medium uppercase tracking-wider ${cfg.cls}`}
    >
      {status === "processing" && (
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-sky-400" />
      )}
      {cfg.label}
    </span>
  );
}
